import { NavLink } from "react-router-dom";
import { LayoutDashboard, BarChart3, ClipboardList, Upload, MapPinned, Settings, ShieldCheck, FileBarChart, BookOpenText, Sparkles, Radar } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const NAV = [
  { to: "/dashboard", label: "Cuadro de mando", icon: LayoutDashboard, roles: ["admin", "jefe_servicio", "oficina", "lectura"] },
  { to: "/barometro", label: "Barómetro IRIS", icon: BarChart3, roles: ["admin", "jefe_servicio", "oficina", "lectura"] },
  { to: "/incidencias", label: "Incidencias", icon: ClipboardList, roles: ["admin", "jefe_servicio", "oficina", "lectura"] },
  { to: "/importar", label: "Importar fichas", icon: Upload, roles: ["admin", "jefe_servicio", "oficina"] },
  { to: "/rutas", label: "Rutas de calidad", icon: MapPinned, roles: ["admin", "jefe_servicio", "oficina", "lectura"] },
  { to: "/mapa-en-vivo", label: "Mapa en vivo", icon: Radar, roles: ["admin", "jefe_servicio", "oficina"] },
  { to: "/informes", label: "Informes", icon: FileBarChart, roles: ["admin", "jefe_servicio", "oficina"] },
  { to: "/asistente", label: "Asistente IA", icon: Sparkles, roles: ["admin", "jefe_servicio", "oficina"] },
  { to: "/administracion", label: "Administración", icon: Settings, roles: ["admin", "jefe_servicio"] },
];

export function Sidebar() {
  const { user } = useAuth();
  const items = NAV.filter((n) => user && n.roles.includes(user.role));
  return (
    <aside className="hidden md:flex h-screen w-64 flex-col border-r border-border bg-card/60 shrink-0">
      <div className="flex items-center gap-3 px-6 py-6 border-b border-border">
        <img src="https://valorizasm.com/templates/valoriza/images/logos/VALORIZA_color_negativo.svg" alt="Valoriza" className="h-6 dark:invert-0 invert" />
      </div>
      <div className="px-6 pt-5 pb-2">
        <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-bold flex items-center gap-1.5">
          <ShieldCheck className="h-3.5 w-3.5 text-valoriza-leaf" /> SENTINEL BCN
        </p>
      </div>
      <nav className="flex-1 px-3 space-y-1 mt-2" data-testid="sidebar-nav">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`nav-link-${to.replace("/", "")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive ? "bg-valoriza-leaf text-black" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              }`
            }
          >
            <Icon className="h-4 w-4 shrink-0" strokeWidth={1.5} />
            {label}
          </NavLink>
        ))}
      </nav>
      <div className="px-6 py-4 text-[10px] text-muted-foreground border-t border-border space-y-2">
        <a
          href="/manual_sentinel_bcn.pdf"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="download-user-manual-link"
          className="flex items-center gap-1.5 font-bold text-valoriza-leaf hover:underline"
        >
          <BookOpenText className="h-3.5 w-3.5" /> Manual de usuario (PDF)
        </a>
        <div>
          Zona Nord — Barcelona
          <br />
          Confidencial de contrato
        </div>
      </div>
    </aside>
  );
}
